import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";

const Level = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const parmas = useParams();
  const getListDataByid = async () => {
    setIsLoading(true);
    const data = {
      id: parmas?.mid,
    };
    await tutorsModal
      .TeachingPreferencelist(data)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setDataList(result?.data?.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (parmas.mid != "") {
      getListDataByid();
    }
  }, []);

  // const du = new DeviceUUID();
  // const uuid = du.get();
  const handleDownload = (url) => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Popup blocked. Please enable popups and try again.");
    }
  };
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [modal1, setModal1] = useState(false);
  const toggle1 = () => setModal1(!modal1);

  const [modal2, setModal2] = useState(false);
  const toggle2 = () => setModal2(!modal2);

  const [interviewUserList, setInterviewUserList] = useState([]);
  const getListDatainterViewUSer = async () => {
    setIsLoading(true);
    await SubAdminModal.list()
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setInterviewUserList(result.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getListDatainterViewUSer();
  }, []);

  const [selectuser, setSelectdUser] = useState("");
  const interViewUser = (id) => {
    setSelectdUser(id);
  };
  console.log(selectuser, "selectuser");

  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();

  const [meetingDate, setMeetingDate] = useState("");
  const handleDateChange = (event) => {
    const { value } = event.target;
    setMeetingDate(value); // Update meetingDate state with the selected date
  };
  const formattedDate = moment(meetingDate).format("DD/MM/YYYY");
  const [startTime, setStartTime] = useState(""); // State to store start time
  const [endTime, setEndTime] = useState(""); // State to store end time
  const [interviewLink, setInterViewLink] = useState("");

  // Function to handle changes in the start time input
  const handleStartTimeChange = (event) => {
    const { value } = event.target;
    setStartTime(value); // Update startTime state with the selected time
  };

  // Function to handle changes in the end time input
  const handleEndTimeChange = (event) => {
    const { value } = event.target;
    setEndTime(value); // Update endTime state with the selected time
  };

  const handleInterViewLink = (event) => {
    const { value } = event.target;
    setInterViewLink(value); // Update endTime state with the selected time
  };

  const handleSubmitAddedInterView = (event) => {
    event.preventDefault();
    const formdata = new FormData();
    formdata.append("tutor", parmas?.mid);
    formdata.append("interviewer", selectuser);
    formdata.append("interview_link", interviewLink);
    formdata.append("interview_date", formattedDate);
    formdata.append("start_time",moment(startTime, "HH:mm").format("hh:mm A"));
    formdata.append("end_time",moment(endTime, "HH:mm").format("hh:mm A"));
    

    SubAdminModal.InterviewSchedule(formdata)
      .then((response) => {
        console.log(response, "forminterdfview");
        // helper.sweetalert.toast("Interview Shedule.", "success");
        // toggle()
        // setAddsLoadig(false);
      })
      .catch((error) => {
        console.log(error, "forminterview");
        // setAddsLoadig(false);
        // console.log(error);
      });
  };

  return (
    <div>
      <div  >
        <Button onClick={toggle}   style={{marginBottom:"10px"}}>
            Add Level+
        </Button>
        <div  style={{ overflowX: "auto" }}>

     
      <Table>
  <thead>
    <tr style={{ background: "#F6F9FC" }}>
      <th>SN No.</th>
      <th>Level Name</th>
      <th>Price Start</th>
      <th>Price Up-to</th>
      <th>Description</th>
      <th>Action</th>
    </tr>
  </thead>
  {/* {!isLoading && ( */}
    <tbody>
      {/* {dataList.length > 0 ? (
        dataList
          ?.slice()
          .reverse()
          .map((item, index) => {
            return ( */}
              <tr className="vertical-align-middle" style={{ cursor: "pointer", verticalAlign: "middle" }}>
                <td>1</td>
                <td>Level 1</td>
                <td>50000</td>
                <td>5000000000</td>
                <th>hye tutor</th>
             
                <td>

                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-icon-only text-light"
                      role="button"
                      size="sm"
                      color=""
                    >
                      <i className="fas fa-ellipsis-v" />
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-arrow " right>
                      <DropdownItem onClick={toggle} className="text-dark">
                       Edit
                      </DropdownItem>
                    
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </td>
              </tr>
    {/* //         );
    //       })
    //   ) : (
    //     <tr style={{ textAlign: "center", verticalAlign: "middle" }}>
    //       <td colSpan="6">No data found</td>
    //     </tr>
    //   )}
    </tbody>
  )} */}
     </tbody>
</Table>
</div>
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            <h4>Add Level</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Select Level</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      interViewUser(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    <option value="">Level 1</option>
                    <option value="">Level 2</option>
                    <option value="">Level 3</option>
                    <option value="">Level 4</option>
                  
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Price Start</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="text"
                    // name="interview_link"
                    placeholder="Enter Ammount"
                 
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Price Up To</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="text"
                    // name="interview_link"
                    placeholder="Enter Ammount"
                 
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Description</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="textarea"
                    // name="interview_link"
                    placeholder="Enter Description"
                 
                  />
                </FormGroup>
              </Col>
          
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                onClick={handleSubmitAddedInterView}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal2} toggle={toggle2}>
          <ModalHeader toggle={toggle2}>
            <h4>Interview Status Chnage</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Status</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      interViewUser(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    <option value="">Qualified </option>
                    <option value="">Not Qualified </option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Feedback</Label>
                  <Input
                    id="type"
                    name="Feedback"
                    type="textarea"
                    placeholder="Enter Feedback"
                  />
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle2}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                onClick={handleSubmitAddedInterView}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal1} toggle={toggle1}>
          <ModalHeader toggle={toggle1}>
            <h4>Interview Schedule User List</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Select Interviewer</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      interViewUser(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    {interviewUserList &&
                      interviewUserList.map((item, index) => {
                        return <option value={item.mobile}>{item.name}</option>;
                      })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Meeting Link</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="text"
                    // name="interview_link"
                    placeholder="Enter meeting link"
                    value={interviewLink} // Set the value of the input field to the meetingDate state
                    onChange={handleInterViewLink}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="meetingDate">Meeting Date</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="date"
                    id="meetingDate"
                    // name="interview_date"
                    placeholder="Select meeting date"
                    value={meetingDate} // Set the value of the input field to the meetingDate state
                    onChange={handleDateChange} // Call handleDateChange function when the date is changed
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="startTime">Start Time</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="time"
                    id="startTime"
                    value={startTime} // Convert to 12-hour format
                    onChange={handleStartTimeChange} // Call handleStartTimeChange function when the time is changed
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="endTime">End Time</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="time"
                    id="endTime"
                    value={endTime} // Convert to 12-hour format
                    onChange={handleEndTimeChange} // Call handleEndTimeChange function when the time is changed
                  />
                </FormGroup>
              </Col>
              {/* <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Select Interviewer</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      interViewUser(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    <option value="">Pending</option>
                    <option value="">Interview scheduled</option>
                   
                  </Input>
                </FormGroup>
              </Col> */}
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                onClick={handleSubmitAddedInterView}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>

      <br />
    </div>
  );
};

export default Level;
